import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed, when} from 'mobx';

import DeloitteSignIn from './component';
import BaseContentModel from 'base-contentmodel';

import {RoleContentModel} from 'configuration-entity/contentmodel';

export class DeloitteAuthContentModel extends BaseContentModel{
  static _slots = {
    title: "",
    welcomeMessage: "",
    headerMessage: "",
    signUpMessage: "",
    allowSignupFor: RoleContentModel,
    authCode: ""
  }
  Component = DeloitteSignIn

  /* @slot */ @observable title = ""
  /* @slot */ @observable welcomeMessage = ""
  /* @slot */ @observable headerMessage = ""
  /* @slot */ @observable signUpMessage = ""
  /* @slot */ @observable.ref allowSignupFor = null
  static _meta = {
    allowSignupFor: {
      // @TODO actually implement :-)
      hideMenu: ["add"]
    }
  }

  @observable authCode = "Regis123"
  @observable done = false
}
export default DeloitteAuthContentModel;



// WEBPACK FOOTER //
// ./app_modules/deloitte-auth-strategy/contentmodel.js